import React, { useEffect } from "react";
import logo from "../../assets/merchant-marvels.jpg";
import Image from "../../assets/intro-clover-flex.jpg";
import "./ThankYouPage.css";

export default function ThankYouPage() {

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      window.fbq("track", "Lead");
    }
  }, []);

  return (
    <div className="thankyou-page">
      <section className="thankyou-hero">
        <div className="thankyou-image-wrap">
          <img
            src={Image}
            alt="Card payment device"
            className="thankyou-image"
          />
        </div>

        <div className="thankyou-content">
          <div className="brand-wrap">
            <img
              src={logo}
              alt="Merchant Marvels logo"
              className="brand-logo"
            />
          </div>

          <h1>Thank you!</h1>
          <p>A member of our grow team will contact you shortly</p>

          {/* Buttons */}
          <div className="thankyou-buttons">

            

            <a
              href="tel:+13022086030"
              className="call-btn"
            >
              Call Now
            </a>

          </div>
        </div>
      </section>
    </div>
  );
}